var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("default", function () {
        return [
          _c(
            "a",
            {
              directives: [
                {
                  name: "analytics",
                  rawName: "v-analytics",
                  value: { label: "header_logo" },
                  expression: "{label:'header_logo'}",
                },
              ],
              staticClass: "global-navi-default-logo",
              attrs: { href: _vm.link },
            },
            [_vm._v("@cosme")]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }